import Card from "../Reusable/Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

export default function Cards() {
  const data = [
    {
      name: "Total Payroll",
      count: 10,
    },
    {
      name: "Total Paid",
      count: 10,
    },
    {
      name: "Total Unpaid",
      count: 10,
    },
    {
      name: "Pending Payment",
      count: 10,
    },
  ];
  return (
    <div className={tw`grid grid-cols-4 gap-4`}>
      {data.map((d, i) => (
        <Card key={i} title={d.name}>
          <p>Rs. {d.count}</p>
        </Card>
      ))}
    </div>
  );
}
